import { ApiError } from "@/api/client";
import { apiErrorMessage } from "@/lib/api-error-kind";

/**
 * An API refusal as the user reads it: the server's message and its
 * `error_code`, then its reasons — each of its `details.diagnostics` (the
 * project spec routes' `spec_invalid` and `revision_stale_against_source`,
 * Phase 2 C2.2) and each port of its `details.unbound` (a submit's
 * `inputs_unbound`, fs#2553). A refusal without its reasons is not actionable.
 */
export function RefusalDetail({ error }: { error: unknown }): JSX.Element {
  if (!(error instanceof ApiError)) return <>{apiErrorMessage(error)}</>;
  const diagnostics = Array.isArray(error.details?.diagnostics)
    ? (error.details.diagnostics as Array<{ message?: unknown }>)
    : [];
  const unbound = Array.isArray(error.details?.unbound)
    ? (error.details.unbound as unknown[]).filter((p): p is string => typeof p === "string")
    : [];
  const reasons = [
    ...diagnostics.map((d) => (typeof d.message === "string" ? d.message : JSON.stringify(d))),
    ...unbound,
  ];
  return (
    <>
      {error.message} <span className="font-mono text-xs">({error.errorCode})</span>
      {reasons.length > 0 && (
        <ul className="mt-1 list-disc pl-5 text-xs">
          {reasons.map((reason, i) => (
            <li key={i} className={i >= diagnostics.length ? "font-mono" : undefined}>
              {reason}
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
